//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'FamilyDetailRow',
    props: {
        index: {
            type: Number,
            required: true
        },
        row: {
            type: Object,
            required: true
        },
        is_new: {
            type: Boolean,
            required: true
        },
        set_value: {
            type: Function,
            required: true
        },
    },
    computed: {
        calc_class_names() {
            return {
                'row': true,
                'form-section': true,
                'visible-section': true,
                'full-bleed': this.index % 2 !== 0,
            };
        },
        section_head() {
            const { row } = this;
            if (row.full_name) {
                return `${row.full_name}`;
            } else {
                return "New Row";
            }
        },
        relationship_options() {
            return [	
                "",
                "Wife",
                "Uncle",
                "Step Mother",
                "Step Father",
                "Spouse",
                "Son in Law",
                "Son",
                "Sister in Law",
                "Sister",
                "Partner",
                "Niece",
                "Nephew",
                "Neighbor",
                "Mother in Law",
                "Mother",
                "Husband",
                "Guardian",
                "Great Uncle",
                "Great Aunt",
                "Grandmother",
                "Grandfather",
                "Godfather",
                "Friend",
                "Father in Law",
                "Father",
                "Daughter in Law",
                "Daughter",
                "Cousin's Wife",
                "Cousin's Husband",
                "Cousin",
                "Common Law",
                "Brother in Law",
                "Brother",
                "Aunt",
            ];
        }
    },
    methods: {
        handle_delete_row() {
            this.$emit("delete-row", this.index);
        },
    },
}
